<template>
	<div :class="{'modal fade': true, 'show': isVisible}"
		id="modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="modal"
		ref="modal" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title d-inline">
						<slot name="title"></slot>
					</h5>
					<button @click="close()" type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<slot name="body"></slot>
				</div>
				<div class="modal-footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: "ModalComponent",
		data() {
			return {
				modal: null,
			}
		},
		computed: {
			isVisible() {
				return this.$store.getters.isVisibleModal;
			},
		},
		methods: {
			open() {
				this.$store.dispatch('updateModalVisible', true);
				this.$emit('open');
			},

			close() {
				this.$store.dispatch('updateModalVisible', false);
				this.$emit('close');
			},
			afterOpen() {
				this.$emit('mounted');
			},

			afterClose() {
				this.$emit('destroyed');
			},
		},
		mounted() {
			this.$nextTick(() => {
				this.modal = this.$refs.modal;
			});
		},
	};
</script>

<style scoped>
	.show {
		display: block !important;
	}
</style>